import { ArticleGroupQuery, ArticleGroupQueryVariables } from './__generated__/ArticleGroupQuery';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ARTICLE_GROUP_QUERY } from './articleGroup.query';

export const useArticleGroupQuery = (variables: ArticleGroupQueryVariables) => {
  return useQuery<ArticleGroupQuery>(ARTICLE_GROUP_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};

export const useArticleGroupLazyQuery = (variables: ArticleGroupQueryVariables) => {
  return useLazyQuery<ArticleGroupQuery>(ARTICLE_GROUP_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
